module.exports = __webpack_public_path__ + "static/portfolio-3-f243b2f9a29262c08c6c7330b727011b.jpg";